// extracted by css-extract-rspack-plugin
export default {"backLink":"RepositorySavedViewPage-module__backLink__ivBkK"};